import FrequentationTransportPublic from "./indicators/FrequentationTransportPublic";
import Motorisation from "./indicators/Motorisation";
import TauxMobiliteQuotidien from "./indicators/TauxMobiliteQuotidien";
import RepartitionModaleDeplacementsQuotidiens from "./indicators/RepartitionModaleDeplacementsQuotidiens";
import NbDeplacementsQuotidiens from "./indicators/NbDeplacementsQuotidiens";
import TauxImmobilite from "./indicators/TauxImmobilite";
import FlujosInternos from "./layers/FlujosInternos";
import LineasDeseo from "./layers/LineasDeseo";
import MotorizacionAutos from "./layers/MotorizacionAutos";
import RepartoModal from "./layers/RepartoModal";

const MobilityDemand = {
    idSection: "mobilityDemand",
    questionSection: "",
    treeviews: {
        title: "Mobility Indicators Content.sections.MobilityDemand",
        indicators: {
            checked: 0,
            expand: false,
        },
        layers: {
            checked: 2,
            expand: true,
        },
    },
    layers: {
        flujosInternos: FlujosInternos,
        lineasDeseo: LineasDeseo,
        motorizacionAutos: MotorizacionAutos,
        repartoModal: RepartoModal,
    },
    indicators: {
        repartitionModaleDeplacementsQuotidiens:
            RepartitionModaleDeplacementsQuotidiens,
        nbDeplacementsQuotidiens: NbDeplacementsQuotidiens,
        tauxMobiliteQuotidien: TauxMobiliteQuotidien,
        motorisation: Motorisation,
        frequentationTransportPublic: FrequentationTransportPublic,
        tauxImmobilite: TauxImmobilite,
    },
};

export default MobilityDemand;
